// extracted by mini-css-extract-plugin
export var wordContainer = "_ou-0";